module.exports = __webpack_public_path__ + "img/top5_img3.7de95b03.png";